document.addEventListener("DOMContentLoaded", function() {
  console.log("Script de gestion des variantes chargé");
  
  // Ajouter les styles CSS avec media queries pour éviter la duplication
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    /* Style pour le texte mobile */
    .mobile-sold-out {
      display: none !important;
    }
    
    /* Styles pour mobile uniquement */
    @media (max-width: 767px) {
      .mobile-sold-out {
        display: block !important;
        font-size: 12px;
        font-weight: bold;
      }
      /* Cacher le texte desktop sur mobile */
      button[disabled] .hidden.md\\:block {
        display: none !important;
      }
    }
    
    /* Styles pour desktop uniquement */
    @media (min-width: 768px) {
      /* Cacher le texte mobile sur desktop */
      .mobile-sold-out {
        display: none !important;
      }
    }
    
    /* Style commun pour le bouton désactivé */
    button[type="submit"][disabled] {
      background-color: #f0f0f0 !important;
      color: #666 !important;
      border: 1px solid #ddd !important;
      opacity: 0.8 !important;
      cursor: not-allowed !important;
    }
  `;
  document.head.appendChild(styleElement);
  
  // PARTIE 1: DÉTECTION DE LA LANGUE
  function getCurrentLanguage() {
    const path = window.location.pathname;
    if (path.includes('/de/') || path.startsWith('/de')) return 'de';
    else if (path.includes('/fr/') || path.startsWith('/fr')) return 'fr';
    else return 'en';
  }
  
  const buttonTexts = {
    'fr': { add: 'Ajouter au panier', sold: 'Épuisé', soldMobile: 'Épuisé' },
    'en': { add: 'Add to cart', sold: 'Sold out', soldMobile: 'Sold out' },
    'de': { add: 'In den Warenkorb', sold: 'Ausverkauft', soldMobile: 'Ausverkauft' }
  };
  
  const lang = getCurrentLanguage();
  console.log("Langue détectée:", lang);
  const texts = buttonTexts[lang] || buttonTexts['en'];
  
  // PARTIE 2: INTERCEPTION DES CLICS SUR LES BOUTONS
  function setupButtonListeners() {
    // Ajouter des écouteurs directement sur tous les boutons submit
    document.querySelectorAll("button[type='submit']").forEach(button => {
      if (button.getAttribute("data-listener-added") !== "true") {
        button.setAttribute("data-listener-added", "true");
        
        // Utiliser touchstart pour une meilleure réactivité sur mobile
        button.addEventListener("touchstart", function(event) {
          handleButtonClick(event, this);
        });
        
        // Garder click pour desktop et comme fallback
        button.addEventListener("click", function(event) {
          handleButtonClick(event, this);
        });
      }
    });
  }
  
  function handleButtonClick(event, button) {
    // Trouver le formulaire et les données de variante
    const form = button.closest("form");
    const productWrapper = button.closest(".variant-selector-wrapper");
    
    if (!form || !productWrapper) return;
    
    const variantDataElement = productWrapper.querySelector(".product-variants-json");
    if (!variantDataElement) return;
    
    try {
      // Obtenir l'ID de la variante sélectionnée
      const variantId = form.querySelector("input[name='id']").value;
      
      // Vérifier si la variante est disponible
      const variants = JSON.parse(variantDataElement.textContent);
      const selectedVariant = variants.find(v => v.id.toString() === variantId);
      
      if (selectedVariant && !selectedVariant.available) {
        // Empêcher la soumission du formulaire si la variante est épuisée
        event.preventDefault();
        event.stopPropagation();
        
        console.log("Variante épuisée détectée, affichage du message");
        
        // Afficher "Épuisé" sur le bouton
        showSoldOutMessage(button);
        
        // Retourner false pour empêcher la propagation
        return false;
      }
    } catch (e) {
      console.error("Erreur lors de la vérification de disponibilité:", e);
    }
  }
  
  // PARTIE 3: AFFICHER LE MESSAGE "ÉPUISÉ"
  function showSoldOutMessage(button) {
    console.log("Tentative d'affichage du message 'Épuisé'");
    
    // Arrêter le loader
    const loader = button.querySelector(".btn-loader");
    if (loader) {
      loader.style.display = "none";
      loader.style.opacity = "0";
    }
    
    // Vérifier si c'est un bouton mobile ou desktop
    const isMobileButton = button.querySelector(".md\\:hidden"); // Le sélecteur pour l'icône mobile
    const desktopTextSpan = button.querySelector(".hidden.md\\:block"); // Le span caché sur mobile, visible sur desktop
    
    // Stocker l'état original du bouton si ce n'est pas déjà fait
    if (!button.hasAttribute("data-original-text") && desktopTextSpan) {
      button.setAttribute("data-original-text", desktopTextSpan.textContent);
    }
    
    // Mettre à jour le texte pour desktop
    if (desktopTextSpan) {
      desktopTextSpan.textContent = texts.sold;
      console.log("Texte desktop mis à jour:", desktopTextSpan.textContent);
    }
    
    // Gérer l'affichage mobile
    if (isMobileButton) {
      // C'est un bouton mobile avec une icône
      console.log("Bouton mobile détecté");
      
      // Cacher l'icône du panier
      isMobileButton.style.display = "none";
      
      // Créer un span pour le texte "Épuisé" s'il n'existe pas déjà
      if (!button.querySelector(".mobile-sold-out")) {
        const btnText = button.querySelector(".btn-text");
        
        if (btnText) {
          // Créer le texte "Épuisé" pour mobile
          const soldOutText = document.createElement("span");
          soldOutText.className = "mobile-sold-out";
          soldOutText.textContent = texts.soldMobile; // Utiliser "Épuisé" pour mobile
          
          // Ajouter le texte au bouton
          btnText.appendChild(soldOutText);
          console.log("Texte 'Épuisé' ajouté au bouton mobile");
        }
      }
    }
    
    // Appliquer un style au bouton
    button.style.backgroundColor = "#f0f0f0";
    button.style.color = "#666";
    button.style.border = "1px solid #ddd";
    button.style.opacity = "0.8";
    button.style.cursor = "not-allowed";
    
    // Désactiver le bouton
    button.setAttribute("disabled", "disabled");
    button.setAttribute("aria-disabled", "true");
  }
  
  // PARTIE 4: RÉINITIALISER LES BOUTONS LORS DU CHANGEMENT DE VARIANTE
  function setupVariantChangeListeners() {
    // Boutons de variante desktop
    document.querySelectorAll(".variant-desktop button").forEach(button => {
      button.addEventListener("click", function() {
        const productWrapper = this.closest(".variant-selector-wrapper");
        if (!productWrapper) return;
        
        // D'abord réinitialiser le bouton
        resetAddToCartButton(productWrapper);
        
        // Mettre à jour les écouteurs de boutons
        setTimeout(function() {
          setupButtonListeners();
        }, 100);
      });
    });
    
    // Sélecteurs de variante mobile
    document.querySelectorAll(".single-option-selector").forEach(selector => {
      selector.addEventListener("change", function() {
        const productWrapper = this.closest(".variant-selector-wrapper");
        if (!productWrapper) return;
        
        // D'abord réinitialiser le bouton
        resetAddToCartButton(productWrapper);
        
        // Mettre à jour les écouteurs de boutons
        setTimeout(function() {
          setupButtonListeners();
        }, 100);
      });
    });
  }
  
  // PARTIE 5: RÉINITIALISER LE BOUTON D'AJOUT AU PANIER
  function resetAddToCartButton(productWrapper) {
    const submitButton = productWrapper.querySelector("button[type='submit']");
    if (!submitButton) return;
    
    console.log("Réinitialisation du bouton d'ajout au panier");
    
    // Réinitialiser le style du bouton
    submitButton.style.backgroundColor = "";
    submitButton.style.color = "";
    submitButton.style.border = "";
    submitButton.style.opacity = "";
    submitButton.style.cursor = "";
    
    // Réactiver le bouton
    submitButton.removeAttribute("disabled");
    submitButton.removeAttribute("aria-disabled");
    
    // Réinitialiser le texte sur desktop
    const desktopTextSpan = submitButton.querySelector(".hidden.md\\:block");
    if (desktopTextSpan && submitButton.hasAttribute("data-original-text")) {
      desktopTextSpan.textContent = submitButton.getAttribute("data-original-text");
    }
    
    // Réinitialiser sur mobile
    const mobileIcon = submitButton.querySelector(".md\\:hidden");
    if (mobileIcon) {
      mobileIcon.style.display = "";
    }
    
    // Supprimer le texte "Épuisé" sur mobile s'il existe
    const soldOutText = submitButton.querySelector(".mobile-sold-out");
    if (soldOutText) {
      soldOutText.remove();
    }
    
    // Réinitialiser le loader
    const loader = submitButton.querySelector(".btn-loader");
    if (loader) {
      loader.style.display = "";
      loader.style.opacity = "";
    }
  }
  
  // PARTIE 6: EXÉCUTION
  
  // Configurer les écouteurs de boutons
  setupButtonListeners();
  
  // Configurer les écouteurs de changement de variante
  setupVariantChangeListeners();
  
  // Observer les changements dans le DOM pour ajouter des écouteurs aux nouveaux boutons
  const observer = new MutationObserver(function(mutations) {
    setupButtonListeners();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Réexécuter lors d'un changement d'URL (pour les filtres)
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      setTimeout(function() {
        setupVariantChangeListeners();
        setupButtonListeners();
      }, 1000);
    }
  }).observe(document, { subtree: true, childList: true });
});